import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=1f932a62"
import script from "./OrderOverview.vue?vue&type=script&lang=js"
export * from "./OrderOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports